import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Modal } from '@mui/material';
import { modalBoxStyle, modalSubtitleStyle, modalTitleStyle } from '../../../../../styles/modalStyle';
import { t } from 'i18next';
import useIsMobile from '../../../../../hooks/useIsMobile';
import { render } from '../../../../../utils/translation';

interface ConfirmModalProps {
	title: string;
	subtitle: string;
	state: boolean;
	setState: (value: boolean) => void;
	confirmHandler: () => void;
	abortHandler: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    title,
    subtitle,
    state,
    setState,
    confirmHandler,
    abortHandler
}: ConfirmModalProps): ReactElement => {
    const [isMobile, setIsMobile] = useState(false);
    useEffect((): () => void => useIsMobile(setIsMobile), []);

    return <Modal
        open={state}
        onClose={setState}
        aria-labelledby='confirm-modal-title'
        aria-describedby='confirm-modal-description'
    >
        <Box sx={modalBoxStyle(isMobile)}>
            <h2 id="info-modal-title" style={modalTitleStyle()}>
                {title.toUpperCase()}
            </h2>

            <p id="dirty-modal-subtitle" className="mt-2 mb-4" style={modalSubtitleStyle()}>
                {render(subtitle)}
            </p>

            <div className='row' style={{ width: "100%" }}>
                <div className='col-6 text-end'>
                    <button className='custom-button custom-yes-button' onClick={confirmHandler}>
                        {t('common.yes').toUpperCase()}
                    </button>
                </div>
                <div className='col-6 text-start'>
                    <button className='custom-button custom-no-button' onClick={abortHandler}>
                        {t('common.no').toUpperCase()}
                    </button>
                </div>
            </div>
        </Box>
    </Modal>;
}

export default ConfirmModal;
